export default __webpack_public_path__ + "static/media/biboo1.21a43ef9.png";